/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {matchRoutes, useLocation} from "react-router-dom"
import {ARGOS_ROUTES} from "../Routes/constants";

const useGetCurrentPath = () => {
  const location = useLocation()
  const routesList = matchRoutes(ARGOS_ROUTES, location)
  return routesList?.[0]?.pathname
}

export default useGetCurrentPath;
